import {BaseDtoModel} from '../../../../Services/Models/base-model.service';
import {endOfMonth, format, startOfMonth} from 'date-fns';

export class TasksReportFilters extends BaseDtoModel {
  familia_local!: boolean;
  id_local!: number[];
  id_familia_local!: number[];
  fecha_inicio!: string;
  fecha_fin!: string;
  top_10!: boolean;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      familia_local: false,
      id_local: [],
      id_familia_local: [],
      fecha_inicio: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
      fecha_fin: format(endOfMonth(new Date()), 'yyyy-MM-dd'),
      top_10: true,
    });
  }
}
